/** Static rows and watchlists for the Scanner visual-refresh preview.
 *
 * Layout fixture only. Not wired to the production Scanner, cache, or any
 * provider. Watchlist names match the MarkovLab model; membership is mock.
 */

function row(partial) {
  return {
    technicalState: "Range",
    fundamentalState: "Mixed",
    confirmedRegime: "Quiet Range",
    confidence: 0.64,
    earnings: { date: "2026-10-22", quality: "expected", daysTo: 48 },
    optionsState: "observed",
    incomeContext: "clear",
    cause: null,
    workspaceTicker: false,
    ...partial,
  };
}

export const SCANNER_REFRESH_ROWS = [
  {
    ticker: "ULTA",
    name: "Ulta Beauty, Inc.",
    sector: "Consumer Discretionary",
    technicalScore: 6.8,
    technicalState: "Range",
    fundamentalScore: 7.4,
    fundamentalState: "Solid",
    confirmedRegime: "Quiet Range",
    confidence: 0.78,
    earnings: { date: "2026-09-18", quality: "confirmed", daysTo: 12 },
    optionsState: "observed",
    incomeContext: "flag",
    cause: "Confirmed earnings event falls inside selected time window",
    workspaceTicker: true,
  },
  {
    ticker: "AVAV",
    name: "AeroVironment, Inc.",
    sector: "Industrials",
    technicalScore: 3.4,
    technicalState: "Stressed",
    fundamentalScore: 5.2,
    fundamentalState: "Mixed",
    confirmedRegime: "transitioning",
    confidence: 0.83,
    earnings: { date: "2026-12-03", quality: "predicted", daysTo: 88 },
    optionsState: "unverified",
    incomeContext: "unavailable",
    cause: "Option quote timestamp is unavailable",
    workspaceTicker: true,
  },
  {
    ticker: "BWXT",
    name: "BWX Technologies, Inc.",
    sector: "Industrials",
    technicalScore: 7.2,
    technicalState: "Constructive",
    fundamentalScore: 6.6,
    fundamentalState: "Adequate",
    confirmedRegime: "Quiet Range",
    confidence: 0.71,
    earnings: { date: "2026-11-04", quality: "expected", daysTo: 61 },
    optionsState: "observed",
    incomeContext: "clear",
    cause: null,
    workspaceTicker: false,
  },
  {
    ticker: "AAPL",
    name: "Apple Inc.",
    sector: "Information Technology",
    technicalScore: 7.9,
    technicalState: "Uptrend",
    fundamentalScore: 8.1,
    fundamentalState: "Strong",
    confirmedRegime: "Quiet Range",
    confidence: 0.61,
    earnings: { date: "2026-10-29", quality: "expected", daysTo: 53 },
    optionsState: "partial",
    incomeContext: "flag",
    cause: "Required quote fields are unavailable",
    workspaceTicker: true,
  },
  {
    ticker: "CRWD",
    name: "CrowdStrike Holdings, Inc.",
    sector: "Information Technology",
    technicalScore: null,
    technicalState: "Preparing",
    fundamentalScore: null,
    fundamentalState: "Preparing",
    confirmedRegime: null,
    confidence: null,
    earnings: { date: null, quality: "unavailable", daysTo: null },
    optionsState: "preparing",
    incomeContext: "preparing",
    cause: null,
    workspaceTicker: false,
  },
  row({ ticker: "MSFT", name: "Microsoft Corporation", sector: "Information Technology", technicalScore: 8.2, fundamentalScore: 8.4, technicalState: "Uptrend", fundamentalState: "Strong" }),
  row({ ticker: "UNH", name: "UnitedHealth Group", sector: "Health Care", technicalScore: 6.1, fundamentalScore: 7.2, technicalState: "Range", fundamentalState: "Solid" }),
  row({ ticker: "JPM", name: "JPMorgan Chase", sector: "Financials", technicalScore: 7.0, fundamentalScore: 7.6, technicalState: "Constructive", fundamentalState: "Solid" }),
  row({ ticker: "XOM", name: "Exxon Mobil", sector: "Energy", technicalScore: 5.4, fundamentalScore: 6.8, technicalState: "Mixed", incomeContext: "flag", cause: "Does not meet current liquidity parameters" }),
  row({ ticker: "CAT", name: "Caterpillar", sector: "Industrials", technicalScore: 6.6, fundamentalScore: 6.9 }),
  row({ ticker: "HD", name: "Home Depot", sector: "Consumer Discretionary", technicalScore: 6.3, fundamentalScore: 7.1 }),
  row({ ticker: "KO", name: "Coca-Cola", sector: "Consumer Staples", technicalScore: 5.8, fundamentalScore: 6.4 }),
  row({ ticker: "META", name: "Meta Platforms", sector: "Communication Services", technicalScore: 7.7, fundamentalScore: 7.9, technicalState: "Uptrend" }),
  row({ ticker: "NEE", name: "NextEra Energy", sector: "Utilities", technicalScore: 5.9, fundamentalScore: 6.2 }),
  row({ ticker: "AMT", name: "American Tower", sector: "Real Estate", technicalScore: 5.1, fundamentalScore: 5.8 }),
  row({ ticker: "LIN", name: "Linde", sector: "Materials", technicalScore: 6.4, fundamentalScore: 7.0 }),
  row({ ticker: "LMT", name: "Lockheed Martin", sector: "Industrials", technicalScore: 6.0, fundamentalScore: 6.5, incomeContext: "unavailable", cause: "Outside current portfolio parameters" }),
  row({ ticker: "PWR", name: "Quanta Services", sector: "Industrials", technicalScore: 7.1, fundamentalScore: 6.3, technicalState: "Constructive" }),
  row({ ticker: "SPY", name: "SPDR S&P 500 ETF", sector: "Index Funds", technicalScore: 7.4, fundamentalScore: 7.0 }),
  row({ ticker: "QQQ", name: "Invesco QQQ Trust", sector: "Index Funds", technicalScore: 7.6, fundamentalScore: 7.1 }),
];

export const SCANNER_WATCHLISTS = [
  { id: "my", group: "personal", label: "My Watchlist", tickers: ["ULTA", "AAPL", "AVAV", "BWXT"] },
  { id: "portfolio", group: "portfolio", label: "Portfolio", tickers: ["AAPL", "ULTA"] },
  { id: "technology", group: "sector", label: "Technology", tickers: ["AAPL", "MSFT", "CRWD"] },
  { id: "healthcare", group: "sector", label: "Healthcare", tickers: ["UNH"] },
  { id: "financials", group: "sector", label: "Financial Services", tickers: ["JPM"] },
  { id: "energy", group: "sector", label: "Energy", tickers: ["XOM"] },
  { id: "industrials", group: "sector", label: "Industrials", tickers: ["CAT", "AVAV", "BWXT"] },
  { id: "cyclical", group: "sector", label: "Consumer Cyclical", tickers: ["ULTA", "HD"] },
  { id: "comms", group: "sector", label: "Communication Services", tickers: ["META"] },
  { id: "defensive", group: "sector", label: "Consumer Defensive", tickers: ["KO"] },
  { id: "utilities", group: "sector", label: "Utilities", tickers: ["NEE"] },
  { id: "realestate", group: "sector", label: "Real Estate", tickers: ["AMT"] },
  { id: "materials", group: "sector", label: "Basic Materials", tickers: ["LIN"] },
  { id: "defense", group: "sector", label: "Defense & Aerospace", tickers: ["AVAV", "BWXT", "LMT"] },
  { id: "software", group: "sector", label: "Software", tickers: ["MSFT", "CRWD"] },
  { id: "engineering", group: "sector", label: "Engineering & Construction", tickers: ["PWR", "CAT"] },
  { id: "index", group: "sector", label: "Index Funds", tickers: ["SPY", "QQQ"] },
];

export const SCANNER_FILTERS = {
  regimes: ["all", "Quiet Range", "Bullish Trend", "Bearish Trend", "Volatile", "transitioning"],
  income: ["all", "clear", "flag", "preparing", "unavailable"],
  earnings: ["all", "confirmed", "expected", "predicted", "unavailable"],
  options: ["all", "observed", "partial", "unverified", "preparing", "unavailable"],
};
